export default __webpack_public_path__ + "static/media/team-foto3.55407a71.png";